<template>
  <lottie
    class="stars"
    :options="member"
    :height="size"
    :width="size"
    :animCreated="handleAnimation"
  />
</template>

<script>
import * as honoka from "./members/honoka.json";
import * as eri from "./members/eri.json";
import * as kotori from "./members/kotori.json";
import * as umi from "./members/umi.json";
import * as rin from "./members/rin.json";
import * as maki from "./members/maki.json";
import * as nozomi from "./members/nozomi.json";
import * as hanayo from "./members/hanayo.json";
import * as nico from "./members/nico.json";
import Lottie from "./Lottie.vue";

export default {
  props: {
    star: Object,
  },
  components: {
    Lottie,
  },
  data: () => ({}),
  computed: {
    member() {
      let animeData;
      switch (this.star.member) {
        case 1:
          animeData = honoka;
          break;
        case 2:
          animeData = eri;
          break;
        case 3:
          animeData = kotori;
          break;
        case 4:
          animeData = umi;
          break;
        case 5:
          animeData = rin;
          break;
        case 6:
          animeData = maki;
          break;
        case 7:
          animeData = nozomi;
          break;
        case 8:
          animeData = hanayo;
          break;
        case 9:
          animeData = nico;
          break;
        default:
          return;
      }
      return { animationData: animeData };
    },
    size() {
      switch (this.star.strength) {
        case 0:
          return 200;
        case 1:
          return 400;
        case 2:
          return 600;
      }
    },
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
  },
};
</script>

<style>
.star1 {
  position: fixed;
  top: 100px;
}
.star2 {
  position: fixed;
  top: 150px;
  left: 150px;
}
.star3 {
  position: fixed;
  top:　150px;
  right: 150px;
}
.star4 {
  position: fixed;
  right: 100px;
}
.star5 {
  position: fixed;
  left: 100px;
}
.star6 {
  position: fixed;
  bottom: 150px;
  right: 150px;
}
.star7 {
  position: fixed;
  bottom: 150px;
  left: 150px;
}
.star8 {
  position: fixed;
  bottom: 100px;
}
</style>